import { z } from 'zod';
import { TarificationPeriodSchema } from '../tarification/TarificationFormData';

export const PricingPartitionSchema = z.object({
  price: z.preprocess(
    (value) => (value === '' ? undefined : Number(value)),
    z
      .number({ message: 'Le tarif est requis' })
      .min(0, { message: 'Le tarif est requis' }),
  ),
  firstSpecialPrice: z.coerce
    .number()
    .min(0, { message: 'Ce champ doit être un entier positif' })
    .optional(),
  secondSpecialPrice: z.coerce
    .number()
    .min(0, { message: 'Ce champ doit être un entier positif' })
    .optional(),
  additionalPrice: z.coerce
    .number()
    .min(0, { message: 'Ce champ doit être un entier positif' })
    .optional(),
});

export type PricingPartition = z.infer<typeof PricingPartitionSchema>;

const PricesPartitionsSchema = z.object({
  individual: z.array(PricingPartitionSchema),
  double: z.array(PricingPartitionSchema),
  triple: z.array(PricingPartitionSchema),
  quadruple: z.array(PricingPartitionSchema),
});

export type RoomPricesPartitions = z.infer<typeof PricesPartitionsSchema>;

export const HotelRoomPricingSchema = z.object({
  name: z.string().optional(),
  periods: z
    .array(TarificationPeriodSchema)
    .min(1)
    .refine(
      (data) => {
        if (data.length <= 1) return true;
        for (let i = 1; i < data.length; i++)
          if (data[i].startDate <= data[i - 1].endDate) return false;
        return true;
      },
      {
        path: ['periods'],
        message: 'Les périodes ne peuvent pas se croiser',
      },
    ),
  defaultPricesExist: z.enum(['true', 'false']).optional(),
  defaultPrices: PricingPartitionSchema.omit({
    price: true,
    additionalPrice: true,
  })
    .extend({
      price: z.coerce
        .number()
        .min(0, { message: 'Ce champ doit être un entier positif' })
        .optional(),
    })
    .optional(),
  pricePartitions: PricesPartitionsSchema,
});

export const ExtendedHotelRoomPricingSchema = z.object({
  tarifs: z.array(HotelRoomPricingSchema),
});

export type ExtendedHotelRoomPricingFormData = z.infer<
  typeof ExtendedHotelRoomPricingSchema
>;
